const getBackendUrl = function() {
  if(process.env.REACT_APP_API_ENV == 'local') {
      return 'http://localhost:8085/';
  } else if(process.env.REACT_APP_API_ENV == 'dev') {
      return 'https://accumulator-backend2-dev.hcck8s-ctc.optum.com/';
  } else if(process.env.REACT_APP_API_ENV == 'qa') {
      return 'https://accumulator-backend-qa.hcck8s-ctc.optum.com/';
  } else if (process.env.REACT_APP_API_ENV == "stagectc") {
    return "https://rxclaim-auth-proxy-client-stg-ctc.optum.com/auth-proxy-module/secure/accums/";
  } else if (process.env.REACT_APP_API_ENV == "stageelr") {
    return "https://rxclaim-auth-proxy-client-stg-elr.optum.com/auth-proxy-module/secure/accums/";
  } else if (process.env.REACT_APP_API_ENV == "prodctc") {
    return "https://rxclaim-auth-proxy-client-ctc.optum.com/auth-proxy-module/secure/accums/";
  } else if (process.env.REACT_APP_API_ENV == "prodelr") {
    return "https://rxclaim-auth-proxy-client-elr.optum.com/auth-proxy-module/secure/accums/";
  }
}

export const getPortnousUrl = () => {
  if (process.env.REACT_APP_API_ENV == "local") {
    return "https://rxclaim-auth-proxy-client-dev.hcck8s-ctc.optum.com/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV == "dev") {
    return "https://rxclaim-auth-proxy-client-dev.hcck8s-ctc.optum.com/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV == "qa") {
    return "https://rxclaim-auth-proxy-client-ui-qa-ctc.hcck8s-ctc.optum.com/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV == "stagectc") {
    return "https://rxclaim-auth-proxy-client-stg-ctc.optum.com/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV == "stageelr") {
    return "https://rxclaim-auth-proxy-client-stg-elr.optum.com/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV == "prodctc") {
    return "https://rxclaim-auth-proxy-client-ctc.optum.com/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV == "prodelr") {
    return "https://rxclaim-auth-proxy-client-elr.optum.com/portunus/abilities";
  }
}

export const getBaseURL = (appName) => {
  if (process.env.REACT_APP_API_ENV === "local") {
    switch (appName) {
      case "PATIENT_PAY":
        return "http://localhost:3114";
      default:
        return null;
    }
  } else if (process.env.REACT_APP_API_ENV === "dev") {
    switch (appName) {
      case "PATIENT_PAY":
        return "https://patientpay-frontend-dev.hcck8s-ctc.optum.com";
      default:
        return null;
    }
    //return "https://ps.fe.dev.optum.sapient.com/accums-backend-dev/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV === "qa") {
     //return "hhttp://52.252.70.118/accums-backend-dev/portunus/abilities";

    switch (appName) {
      case "PATIENT_PAY":
        return "https://patientpay-frontend-qa.hcck8s-ctc.optum.com";
      default:
        return null;
    }
  }else if (process.env.REACT_APP_API_ENV === "stagectc") {

   switch (appName) {
     case "PATIENT_PAY":
       return "https://patientpay-nextgen-stg.optum.com";
     default:
       return null;
   }
 }else if (process.env.REACT_APP_API_ENV === "stageelr") {

 switch (appName) {
   case "PATIENT_PAY":
     return "https://patientpay-nextgen-stg.optum.com";
   default:
     return null;
 }
} else if (process.env.REACT_APP_API_ENV === "prodctc") {

  switch (appName) {
    case "PATIENT_PAY":
      return "https://patientpay-nextgen-ctc.optum.com";
    default:
      return null;
  }
}else if (process.env.REACT_APP_API_ENV === "prodelr") {

switch (appName) {
  case "PATIENT_PAY":
    return "https://patientpay-nextgen-elr.optum.com";
  default:
    return null;
}
}
};

export default getBackendUrl;